import { SITE_URL, DEFAULT_LOCALE } from './seo.js';

// These public experiences have translated copy. Additional UI languages can
// still be selected without advertising unfinished translations to crawlers.
export const INDEXABLE_LOCALES = ['en', 'es', 'pt', 'tr'];
export const OG_LOCALES = { en: 'en_US', es: 'es_MX', pt: 'pt_BR', tr: 'tr_TR', hi: 'hi_IN', fr: 'fr_FR' };

export function canonicalUrl(path, locale = DEFAULT_LOCALE) {
  const input = new URL(path, SITE_URL);
  let pathname = input.pathname.replace(/\/+$/, '') || '/';
  if (['/pro', '/pro/yearly'].includes(pathname)) pathname = '/upgrade';
  const url = new URL(pathname, SITE_URL);
  // Only these parameters change the public content. Tracking, authentication,
  // article back-navigation context, and fragments never enter canonical URLs.
  if (pathname === '/blog') {
    const page = input.searchParams.get('page');
    if (/^\d+$/.test(page) && Number.isSafeInteger(Number(page)) && Number(page) > 1) url.searchParams.set('page', String(Number(page)));
    const topic = input.searchParams.get('topic');
    if (topic && /^[a-z0-9][a-z0-9-]*$/i.test(topic)) url.searchParams.set('topic', topic);
  }
  if (locale && locale !== DEFAULT_LOCALE) url.searchParams.set('lang', locale);
  return url.href;
}

export function languageLinks(path, locales = INDEXABLE_LOCALES) {
  if (!locales.length) return [];
  return [
    ...locales.map(locale => ({ key: `language-${locale}`, rel: 'alternate', hreflang: locale, href: canonicalUrl(path, locale) })),
    { key: 'language-default', rel: 'alternate', hreflang: 'x-default', href: canonicalUrl(path) },
  ];
}

export function blogLocales(post) {
  return ['en', ...(typeof post?.content_es === 'string' && post.content_es.trim() ? ['es'] : [])];
}

export function routeNoindex(route) {
  return !!(route.meta?.requiresAuth || route.meta?.seo?.noindex ||
    route.matched?.some(record => record.meta?.requiresAuth) ||
    /^\/auth(?:\/|$)/.test(route.path) ||
    ['/pro/welcome', '/account/blocked'].includes(route.path));
}

export function serializeJsonLd(data) {
  // CMS text cannot terminate the script element in serialized/prerendered HTML.
  return (typeof data === 'string' ? JSON.stringify(JSON.parse(data)) : JSON.stringify(data))
    .replace(/</g, '\\u003c').replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
}

export function seoDate(value) {
  if (!value) return undefined;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? undefined : date.toISOString();
}

export function contentModifiedDate(post, now = new Date()) {
  // Scheduled articles can be edited before publication. Publishing is the
  // newest public content change in that case; ignore invalid/future dates.
  return [post?.updatedAt, post?.updated_at, post?.publishing_date]
    .map(seoDate).filter(value => value && new Date(value) <= now).sort().at(-1);
}
